export const THEME_COOKIE_NAME = "theme"
export const DARKMODE_CLASS_NAME = "dark"
export const DARKMODE_CLASS_VALUE = "thema_dark"